import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import ResultRow from 'components/airspace/ResultRow';
import ResultSection from 'components/airspace/ResultSection';
import {
    EMPTY_STATE_PREFIX,
    EMPTY_STATE_SUFFIX,
    RECENT_SECTION_TITLE,
    RESULTS_SECTION_TITLE
} from 'components/airspace/SearchDrawer/constants';

import { TEST_ID } from './constants';
import type { ForwardFeature, FunctionComponent, Props, RecentEntry } from './types';

import styles from './styles.module.scss';

const renderRecentRow = (
    entry: RecentEntry,
    parentTestId: string,
    handleClick: VoidFunction
): JSX.Element => (
    <ResultRow
        key={entry.id}
        kind='recent'
        onClick={handleClick}
        primary={entry.primary}
        secondary={entry.secondary}
        testId={`${parentTestId}-recent-${entry.id}`}
    />
);

const renderResultRow = (
    feature: ForwardFeature,
    parentTestId: string,
    handleClick: VoidFunction
): JSX.Element => (
    <ResultRow
        key={feature.id}
        kind={feature.kind}
        onClick={handleClick}
        primary={feature.primary}
        secondary={feature.secondary}
        testId={`${parentTestId}-result-${feature.id}`}
    />
);

const ResultsRegion: FunctionComponent<Props> = ({
    className = '',
    isExpanded,
    onPick,
    parentTestId,
    query,
    recents,
    recordRecent,
    results,
    testId = TEST_ID
}) => {
    const showRecent = query.trim().length === 0;
    const showEmpty = !showRecent && results.length === 0;
    const expandedClass = isExpanded ? styles.resultsRegionExpanded : '';

    return (
        <VerticalContainer
            className={`${styles.resultsRegion} ${expandedClass} ${className}`}
            testId={testId}>
            {showRecent && recents.length > 0 ? (
                <ResultSection title={RECENT_SECTION_TITLE}>
                    {recents.map(entry =>
                        renderRecentRow(entry, parentTestId, () => {
                            recordRecent(entry);
                            onPick({ lat: entry.lat, lng: entry.lng });
                        })
                    )}
                </ResultSection>
            ) : null}

            {!showRecent && results.length > 0 ? (
                <ResultSection title={RESULTS_SECTION_TITLE}>
                    {results.map(feature =>
                        renderResultRow(feature, parentTestId, () => {
                            recordRecent({
                                id: feature.id,
                                lat: feature.lat,
                                lng: feature.lng,
                                primary: feature.primary,
                                secondary: feature.secondary
                            });
                            onPick({ lat: feature.lat, lng: feature.lng });
                        })
                    )}
                </ResultSection>
            ) : null}

            {showEmpty ? (
                <Wrapper className={styles.emptyState} testId={`${parentTestId}-emptyState`}>
                    {`${EMPTY_STATE_PREFIX}${query}${EMPTY_STATE_SUFFIX}`}
                </Wrapper>
            ) : null}
        </VerticalContainer>
    );
};

export default ResultsRegion;
